import { render, staticRenderFns } from "./personalRecordMobile.vue?vue&type=template&id=5192918e&scoped=true&"
import script from "./personalRecordMobile.vue?vue&type=script&lang=js&"
export * from "./personalRecordMobile.vue?vue&type=script&lang=js&"
import style0 from "./personalRecordMobile.vue?vue&type=style&index=0&id=5192918e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5192918e",
  null
  
)

export default component.exports